import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CorrectionTypeTableMaintainance, AllocationStatus, downloadCorrectionType } from "../../Services/api";
import instance from "../../redux/api";
import { CommonButton } from "../common/commonButton";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TableContainer,
  Tooltip,
  FormLabel,
  TextField,
  Box,
  Typography,
  Stack,
} from "@mui/material";
import MyComponent from "../EntityTableMaintainance/EntityDetails";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { toast } from "react-toastify";
import EditNoteIcon from "@mui/icons-material/EditNote";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FilterListIcon from "@mui/icons-material/FilterList";
import { ViewAndEditEntity } from "./ViewAndEditEnitty";
import { AddCorrection } from "./AddCorrection";
import { commonToast } from "../common";
import format from "date-fns/format";
import { CommonFilterSidebar, CommonPaginationContainer } from "../common";
import "../common/commonPageStyles.css";
import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";

//styles

const editEntityUpdate = {
  width: "90px",
  padding: "18px 0px",
  borderRadius: "20px",
  gap: "8px",
}

const bankTransactionAddBtn = {
  backgroundColor: "#1672DE",
  color: "white",
  borderRadius: "10px",
  padding: "10px 24px",
  fontWeight: "600",
  fontSize: "14px",
  textTransform: "none",
  minHeight: "40px",
  minWidth: "120px",
  boxShadow: "0 2px 8px rgba(22, 114, 222, 0.2)",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    backgroundColor: "#1565c0",
    boxShadow: "0 4px 12px rgba(22, 114, 222, 0.3)",
    transform: "translateY(-1px)",
  },
};

// Note: legacy search bar styles removed in favor of CommonFilterSidebar

const ResetSubmit = {
  justifyContent: "flex-end",
  paddingTop: "0px",
  marginRight: "12px",
};
const addBankTransactionReset = {
  backgroundColor: "white",
  width: "90px",
  padding: "16px 0px",
  borderRadius: "20px",
  gap: "8px",
  color: "black",
  border: "1px solid black",
};

const EditPageContainerTransactions = {
  padding: "10px",
  cursor: "default",
  width: "100%",
  marginLeft: "-10px",

};
const EditPageContainerTransactionsList = {
  display: "flex",
  justifyContent: "end",
  width: "100%",
  alignItems: "center",
  marginBottom: "10px"
};

const CloseIconStyle = {
  backgroundColor: "#3B3F44",
  color: "#ffff",
  height: "16px",
  width: "16px",
  padding: "7px 8px",
  borderRadius: "32px",
};
const addBankTransactionSubmit = {
  backgroundColor: "#1672DE",
  width: "90px",
  padding: "17px 0px",
  borderRadius: "13px",
  gap: "8px",
  color: "white",
  "&:hover": {
    backgroundColor: "#1565c0",
  },
};
const downloadBtn = {
  backgroundColor: "#1672DE",
  color: "white",
  borderRadius: "10px",
  padding: "10px 24px",
  fontWeight: "600",
  fontSize: "14px",
  textTransform: "none",
  minHeight: "40px",
  minWidth: "120px",
  boxShadow: "0 2px 8px rgba(22, 114, 222, 0.2)",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: "#1565c0",
    boxShadow: "0 4px 12px rgba(22, 114, 222, 0.3)",
    transform: "translateY(-1px)",
  },
  "&:active": {
    transform: "translateY(0)",
  },
  "&:disabled": {
    backgroundColor: "#CCCCCC",
    color: "#ffffff",
    cursor: "not-allowed",
  },
};

export default function CorrectionTypeContainer() {
  // Selectors
  const toggle = useSelector((state) => state.toggleSideMenu);
  const { userData } = useSelector((state) => state?.user);
  const classes = useStyles();
  const [rows, setRows] = useState([
    { correction_type: "", correction_description: "", allocation_status: "" },
  ]);
  const [tableRows, setTableRows] = useState([]);
  const [filteredData, setFilteredData] = useState(tableRows);
  const [isApiCallInprogress, setIsApiCallInprogress] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchStatus, setSearchStatus] = useState(null);
  const [EntityDialog, setEntityDialog] = useState(false);
  const [editRow, setEditRow] = useState("");
  const [viewMode, setViewMode] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isCreated, setIsCreated] = useState(true);
  const [editId, setEditId] = useState("");
  const [allocationStatuss, setAllocationStatus] = useState([]);
  const [filterSidebarOpen, setFilterSidebarOpen] = useState(true);
  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    page: 1,
    pageSize: 25,
  });
  const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);
  const [currentUpdatedFiledsInEditMode, setCurrentUpdatedFiledsInEditMode] =
    useState({});
  const [validationStatus, setValidationStatus] = useState(
    Array(rows.length).fill(true)
  );

  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
    position: "relative",
  };

  useEffect(() => {
    const totalPages = Math.max(
      1,
      Math.ceil((filteredData?.length ?? 0) / (pageState?.pageSize ?? 25))
    );
    setPaginationCount(totalPages - 1);
  }, [filteredData?.length, pageState?.pageSize]);

  useEffect(() => {
    if (isClearPerformed) {
      loadData();
      setIsClearPerformed(false);
    }
  }, [isClearPerformed]);

  const handleDialogClose = () => {
    setEntityDialog(false);
    setEditMode(false);
    setViewMode(false);
    if (!editMode && !viewMode) {
      setRows([
        {
          correction_type: "",
          correction_description: "",
          allocation_status: "",
        },
      ]);
      setSelectedRows([false]);
      setValidationStatus([true]);
    }
    else if(editMode){
      setValidationStatus([true]);
      setCurrentUpdatedFiledsInEditMode({});
    }
  };

  // const handleBrokerBranchDropdown = (index, colName, value, reason, event) => {
  //   const updatedRows = [...rows];
  //   if (updatedRows[index]) {
  //     updatedRows[index][colName] = value;
  //     // Edit Mode

  //     if (editMode) {
  //       setCurrentUpdatedFiledsInEditMode({
  //         ...currentUpdatedFiledsInEditMode,
  //         [colName]: value
  //       });
  //     }
  //   // get broker_information
  //   //   instance.get(`${allocationStatus}+${value}`).then((response) => {
  //   //     if (editMode) {
  //   //       updatedRows[index]['broker_information'] = response?.data?.id;
  //   //       setRows(JSON.parse(JSON.stringify(updatedRows)));
  //   //     } else {  // Add Mode
  //   //       updatedRows[index]['broker_information'] = response?.data?.id;
  //   //       setRows(JSON.parse(JSON.stringify(updatedRows)));
  //   //     }
  //   //   })
  //   // .catch((error) => {
  //   //   console.error("Error fetching data:", error);
  //   // });
  //   } else {
  //     console.error("Row at index", index, "is undefined.");
  //   }
  // };

  const clearSearch = () => {
    setSearchText('')
    setSearchStatus(null)
    setFilteredData(tableRows)
    setIsSearchPerformed(false);
    setIsClearPerformed(true);
  }

  /*
  const handleSearch = (e) => {
    const value = searchText;
    let filterData;
    if (value.trim() === "" && !searchStatus) {
      filterData = tableRows;
    } else {
      filterData = tableRows.filter((row) => {
        const textExists = value.trim() !== "" ? row.correction_type.toLocaleLowerCase().includes(value.toLocaleLowerCase()) : 1 
        const StautsMatch = searchStatus ? row.allocation_status.toLocaleLowerCase().includes(searchStatus.toLocaleLowerCase()) : 1 
        return textExists && StautsMatch;
      })
    }
    setFilteredData(filterData)
  };
  */
  const handleCorrectionTypechange = (name, value) => {
    setSearchText(value ?? "");
    if (isSearchPerformed && !value) {
      if (!searchStatus && !value) {
        clearSearch();
      }
    }
  };

  const handleAllocationStatuschange = (name, value) => {
    setSearchStatus(value ?? null);
    if (isSearchPerformed && !value) {
      if (searchText === "" && !value) {
        clearSearch();
      }
    }
  };

  useEffect(() => {
    setFilteredData(tableRows)
  }, [tableRows])

  useEffect(() => {
    instance
      .get(AllocationStatus)
      .then((response) => setAllocationStatus(response.data))
      .catch((error) =>
        console.error("Error fetching dropdown values:", error)
      );
  }, []);
  const handleCheckboxChange = (index, isChecked) => {
    const updatedSelectedRows = [...selectedRows];
    updatedSelectedRows[index] = isChecked;

    // Check the number of selected rows
    const selectedRowCount = updatedSelectedRows.filter(Boolean).length;

    setSelectedRows(updatedSelectedRows);
    setSelectAll(selectedRowCount === rows.length);
  };

  const handleActionButton = (rowData, isEditMode) => {
    const emptyRows = Array.from({ length: rows.length }, () => ({
      correction_type: "",
      correction_description: "",
      allocation_status: "",
    }));
    if (rowData && isEditMode) {
      // Pre-fill the empty row with data for editing
      setRows([{...rowData}]);
      setEditRow(rowData);
      setEditMode(true);
      setEditId(rowData.id);
      setIsCreated(false);
    } else if (rowData && !isEditMode) {
      setRows([rowData]);
      setViewMode(true);
    } else {
      // If no rowDataForEdit is provided, it means we are in add mode
      setRows(emptyRows);
      setIsCreated(true);
      setEntityDialog(true);
    }
    setEntityDialog(true);
    if (rowData) {
      setIsCreated(false);
    } else {
      setIsCreated(true);
    }
  };


  const handleReset = () => {
    const emptyRows = Array.from({ length: rows.length }, () => ({
      correction_type: "", correction_description: "", allocation_status: "",
    }));
    setRows(emptyRows);
    setSelectedRows([]);
    setSelectAll(false)
    setValidationStatus(Array.from({ length: rows.length }, () => (true)))
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.3, minWidth: 60, headerAlign: "center" },
    {
      field: "correction_type",
      headerName: "Correction Reason",
      flex: 1.2,
      minWidth: 180,
      headerAlign: "center",
    },
    {
      field: "correction_description",
      headerName: "Correction Description",
      flex: 1.5,
      minWidth: 220,
      headerAlign: "center",
    },
    {
      field: "allocation_status",
      headerName: "Allocation Status",
      flex: 1,
      minWidth: 160,
      headerAlign: "center",
    },
    {
      field: "created_by",
      headerName: "Created By",
      flex: 1,
      minWidth: 140,
      headerAlign: "center",
      valueGetter:(params)=>params?.value??"-"
    },
    {
      field: "updated_by",
      headerName: "Last Modified By",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      valueGetter:(params)=>params?.value??"-"
    },
    ...(userData?.role !== "CC Processor" ? [{
      field: "actions",
      headerName: "Actions",
      flex: 0.8,
      minWidth: 120,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {UserAuthorisation?.["View"] === "Y" && (
              <Tooltip title="View">
                <IconButton
                  onClick={() => handleActionButton(params.row, false)}
                  sx={{
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "8px",
                    padding: "6px",
                    width: "32px",
                    height: "32px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.2)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 8px rgba(22, 114, 222, 0.2)",
                    },
                  }}
                >
                  <VisibilityIcon sx={{ fontSize: "16px" }} />
                </IconButton>
              </Tooltip>
            )}
            {UserAuthorisation?.["Edit"] === "Y" && (
              <Tooltip title="Edit">
                <IconButton
                  onClick={() => handleActionButton(params.row, true)}
                  sx={{
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "8px",
                    padding: "6px",
                    width: "32px",
                    height: "32px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.2)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 8px rgba(22, 114, 222, 0.2)",
                    },
                  }}
                >
                  <EditNoteIcon sx={{ fontSize: "16px" }} />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );
      },
    }] : [
      {
        field: "actions",
        headerName: "Actions",
        flex: 0.8,
        minWidth: 100,
        headerAlign: "center",
        align: "center",
        sortable: false,
        renderCell: (params) => {
          return (
            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Tooltip title="View">
                <IconButton
                  onClick={() => handleActionButton(params.row, false)}
                  sx={{
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "8px",
                    padding: "6px",
                    width: "32px",
                    height: "32px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.2)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 8px rgba(22, 114, 222, 0.2)",
                    },
                  }}
                >
                  <VisibilityIcon sx={{ fontSize: "16px" }} />
                </IconButton>
              </Tooltip>
            </Box>
          );
        },
      }
    ]),
  ];
  const loadData = async () => {
    try {
      setIsApiCallInprogress(true);
      let queryParams = ``;
      if (isSearchPerformed) {

        if (searchText) {
          queryParams = `${queryParams}&correction_type=${searchText}`;
        }
        if (searchStatus) {
          queryParams = `${queryParams}&allocation_status=${searchStatus}`;
        }
      }
      const resp = await instance.get(`${CorrectionTypeTableMaintainance}?${queryParams}`);
      setIsApiCallInprogress(false);
      if (resp.status === 200) {
        const sortedData = resp.data.sort((a, b) => b.id - a.id);
        setTableRows(sortedData);
      } else {
        setTableRows([]);
      }
    } catch (err) {
      setIsApiCallInprogress(false);
      console.error("err", err);
    }
  };

  const handleSearchCorrectionTypeList = async () => {
    try {
      let queryParams = ``;

      if (searchText) {
        queryParams = `${queryParams}&correction_type=${searchText}`;
      }

      if (searchStatus) {
        queryParams = `${queryParams}&allocation_status=${searchStatus}`;
      }

      setIsApiCallInprogress(true);

      const resp = await instance.get(`${CorrectionTypeTableMaintainance}?${queryParams}`);

      setIsApiCallInprogress(false);
      if (resp.status === 200) {
        const sortedData = resp.data.sort((a, b) => b.id - a.id);
        setTableRows(sortedData);
        setIsSearchPerformed(true);
      } else {
        setTableRows([]);
      }

    } catch (err) {
      setIsApiCallInprogress(false);
      console.log("err", err);
    }
  };

  const isFilterBtnDisable = () => {
    let disabled = true;
    if (searchText !== "" || searchStatus) {
      disabled = false;
    }
    return disabled;
  }
  const UserAuthorisation =
    userData?.user_permissions?.permissions_list["Admin Table Maintenance"];

  useEffect(() => {
    loadData();
  }, []);
  const handleInputChange = (index, colName, value) => {
    const updatedRows = [...rows];
    if (updatedRows[index]) {
      updatedRows[index][colName] = value;
      setRows(updatedRows);
      // Edit Mode
      if (editMode) {
        setCurrentUpdatedFiledsInEditMode({
          ...currentUpdatedFiledsInEditMode,
          [colName]: value,
        });
      }
    } else {
      console.error("Row at index", index, "is undefined.");
    }
  };
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    const updatedSelectedRows = new Array(rows.length).fill(isChecked);

    setSelectedRows(updatedSelectedRows);
    setSelectAll(isChecked);
  };

  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        correction_type: "",
        correction_description: "",
        allocation_status: "",
      },
    ]);
  };

  useEffect(() => {
    const selectedRowCount = selectedRows.filter(Boolean).length;
    if (selectedRowCount < rows.length) {
      setSelectAll(false)
    }
  }, [rows, selectedRows])


  const handleDeleteRow = () => {
    // Ensure there is at least one row remaining
    if (rows.length <= 1 || selectAll) {
      // Throw an error or show a message indicating that at least one row should remain
      commonToast("error", "At least One Row Should Remain!!");
      return;
    }

    const updatedRows = rows.filter((row, index) => !selectedRows[index]);
    setRows(updatedRows);

    // Clear selected rows and set Select All to false after deletion
    setSelectedRows([]);
    setSelectAll(false);
  };
  const validateRow = (index) => {
    const row = rows[index];
    const fieldValidations = {};

    // Perform your validations here, for example:
    if (!row || !row.correction_type || row.correction_type.trim() === "") {
      fieldValidations.correction_type = "This field is required";
    }
    if (
      !row ||
      !row.correction_description ||
      row.correction_description.trim() === ""
    ) {
      fieldValidations.correction_description = "This field is required";
    }
    if (
      !row ||
      !row.allocation_status ||
      row.allocation_status.trim() === ""
    ) {
      fieldValidations.allocation_status = "This field is required";
    }
    
    // Add more validations for other fields...
    setValidationStatus((prevStatus) => {
      const newStatus = [...prevStatus];
      newStatus[index] = fieldValidations;
      return newStatus;
    });

    return Object.keys(fieldValidations).length === 0;
  };
  const handleSubmit = async () => {
    // Validate each row before submission
   
    const areRowsValid = rows.map((_, index) => validateRow(index)).every((value) => value);

    let editModeObj = {};
    if (!editMode) {
      // Add Mode
    } else {
      editModeObj.id = editRow?.id;
      editModeObj["updated_by"] = userData?.user_name ?? "";

      editModeObj = { ...editModeObj, ...currentUpdatedFiledsInEditMode };
    }
    //const areRowsValid = true;

    if (!areRowsValid) {
      // If any row is invalid, stop the submission and display an error
      commonToast("error", "Please fix validation errors before submitting.");
      return;
    }

    try {
      let response;
      if (editMode) {
        response = await instance.patch(
          CorrectionTypeTableMaintainance + editId + "/",
          editModeObj
        );
        // clear preiously updated stored data
        setCurrentUpdatedFiledsInEditMode({});
      } else {
        // const flattenedRows = rows.flat();
        rows.forEach((item) => {
          item.created_by = userData?.user_name ?? ""
        })
        response = await instance.post(
          CorrectionTypeTableMaintainance,
          rows
        );
      }

      if (response) {
        if (editMode) {
          commonToast("success", "Updated successfully !");
        } else {
          commonToast("success", "Submission successful !");
        }

        // clean up
        cleanupTransactionData();
      }
    } catch (err) {
      commonToast("error", "Submission failed. Please try again.");
    }
  };

  const cleanupTransactionData = () => {
    handleDialogClose();
    loadData();
  };

  const handleEnter = (e) => {
    if (e.code === "Enter") {
      handleSearchCorrectionTypeList();
    }
  };

  const handleDownloadBtnClick = () => {
    setIsDownloadInProgress(true);
    try {
      instance
        .get(`${downloadCorrectionType}`, { responseType: "blob" })
        .then((response) => {
          const url = URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          const fileName = `CorrectionReason_${format(new Date(), "dd-MM-yyyy")}`
          link.setAttribute("download", `${fileName}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setIsDownloadInProgress(false);
          commonToast("success", "Correction Reason data has been downloaded successfully");
        }).catch((err) => {
          console.log(err);
          setIsDownloadInProgress(false);
          commonToast("error", "Correction Reason data could not be downloaded");
        });
    } catch (error) {
      setIsDownloadInProgress(false);
      console.log(error);
      commonToast("error", "Correction Reason data could not be downloaded");
    }
  }
  const handleApplyFilters = () => {
    handleSearchCorrectionTypeList();
  };

  const handleClearFilters = () => {
    clearSearch();
  };

  const handleFieldsInputChange = (name, value) => {
    if (name === "correction_type") {
      handleCorrectionTypechange(name, value);
    } else if (name === "allocation_status") {
      handleAllocationStatuschange(name, value);
    }
  };

  return (
    <>
      <style>
        {`
          /* Override DataGrid column headers to blue theme */
          .MuiDataGrid-root .MuiDataGrid-columnHeaders {
            background-color: #f8f9fa !important;
            border-bottom: 2px solid #e0e0e0 !important;
          }
          .MuiDataGrid-root .MuiDataGrid-columnHeader {
            background-color: transparent !important;
            color: #1672DE !important;
          }
          /* Override DataGrid selection colors to blue - override MUI theme primary color */
          .MuiDataGrid-root .MuiDataGrid-row.Mui-selected,
          .MuiDataGrid-root .MuiDataGrid-row[aria-selected="true"] {
            background-color: rgba(22, 114, 222, 0.08) !important;
          }
          .MuiDataGrid-root .MuiDataGrid-row.Mui-selected:hover,
          .MuiDataGrid-root .MuiDataGrid-row[aria-selected="true"]:hover {
            background-color: rgba(22, 114, 222, 0.12) !important;
          }
          .MuiDataGrid-root .MuiDataGrid-row:hover {
            background-color: rgba(22, 114, 222, 0.04) !important;
          }
          /* Override any orange/yellow colors from theme */
          .MuiDataGrid-root .MuiDataGrid-columnHeaders[style*="#FF"],
          .MuiDataGrid-root .MuiDataGrid-columnHeader[style*="#FF"],
          .MuiDataGrid-root .MuiDataGrid-row.Mui-selected[style*="#FF"],
          .MuiDataGrid-root .MuiDataGrid-row.Mui-selected[style*="ff5"] {
            background-color: rgba(22, 114, 222, 0.08) !important;
          }
        `}
      </style>
    <div style={Container}>
        {/* Filter Sidebar */}
        <CommonFilterSidebar
          isOpen={filterSidebarOpen}
          filterConfigs={[
            {
              type: "textInput",
              label: "Correction Reason",
              placeholder: "Enter Correction Reason",
              value: searchText || "",
              onChange: (value) => handleFieldsInputChange("correction_type", value),
              onKeyUp: (e) => {
                if (e.code === "Enter") {
                  handleApplyFilters();
                }
              },
            },
            {
              type: "textInput",
              label: "Allocation Status",
              placeholder: "Enter Allocation Status",
              value: searchStatus || "",
              onChange: (value) => handleFieldsInputChange("allocation_status", value),
              onKeyUp: (e) => {
                if (e.code === "Enter") {
                  handleApplyFilters();
                }
              },
            },
          ]}
          onApplyFilters={handleApplyFilters}
          onClearFilters={handleClearFilters}
          isLoading={isApiCallInprogress}
          isFilterDisabled={isFilterBtnDisable()}
        />

        {/* Main Content Area */}
        <Box className="main-content-area">
          <Box className="page-header-container">
            <Typography variant="h5" className="page-heading">
          Correction Reason Table
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {UserAuthorisation?.["Creation"] === "Y" && (
            <>
            <CommonButton
              text="Add"
              handleClick={() => handleActionButton()}
              sx={bankTransactionAddBtn}
                    hoverColor="#1565c0"
            />
            <CommonButton
              text="Export"
              handleClick={handleDownloadBtnClick}
              sx={downloadBtn}
                    hoverColor="#1565c0"
              disabled={isDownloadInProgress}
            />
            </>
          )}
              <IconButton
                onClick={() => setFilterSidebarOpen(!filterSidebarOpen)}
                className="filter-toggle-button"
              >
                <FilterListIcon />
              </IconButton>
            </Box>
          </Box>

          <Box
        sx={{
              flex: 1,
          display: "flex",
              flexDirection: "column",
              minHeight: 0,
              position: "relative",
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
              overflow: "hidden",
              transition: "all 0.3s ease",
              border: "1px solid #e8eaf0",
              "&:hover": {
                boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
              },
            }}
          >
            <DataGrid
              className={classes.pagination}
              loading={isApiCallInprogress}
              rows={filteredData ?? []}
              columns={columns}
              rowCount={filteredData?.length ?? 0}
              disableSelectionOnClick
              getRowId={(row) => row?.id}
              pagination
              page={pageState.page - 1}
              pageSize={pageState?.pageSize ?? 25}
              pageSizeOptions={[10, 25, 50, 100]}
              onPaginationModelChange={(model) => {
                setPageState((old) => ({
                  ...old,
                  page: model.page + 1,
                  pageSize: model.pageSize,
                }));
              }}
              components={{
                Toolbar: GridToolbarContainer,
                NoRowsOverlay: () => (
                  <Stack height="100%" alignItems="center" justifyContent="center">
                    No Correction Reason Records
                  </Stack>
                ),
              }}
              sx={{
                border: "none",
                flex: 1,
                minHeight: 0,
                width: "100%",
                "& .MuiDataGrid-root": {
                  border: "none",
                  height: "100%",
                  width: "100%",
                },
                "& .MuiDataGrid-main": {
                  height: "100%",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                    height: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#1672DE",
                    borderRadius: "10px",
                    "&:hover": {
                      background: "#1565c0",
                    },
                  },
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#f8f9fa",
                  borderBottom: "2px solid #e0e0e0",
                  minHeight: "52px !important",
                  maxHeight: "52px !important",
                },
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "transparent",
                  fontWeight: "600",
                  color: "#1672DE",
                  fontSize: "14px",
                  padding: "12px 16px",
                  borderBottom: "none",
                  "&:focus": { outline: "none" },
                  "&:focus-within": { outline: "none" },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: "600",
                    fontSize: "14px",
                  },
                  "& .MuiDataGrid-sortIcon": { color: "#1672DE" },
                  "& .MuiDataGrid-menuIcon": { color: "#1672DE" },
                },
                "& .MuiDataGrid-row": {
                  transition: "all 0.2s ease",
                  borderBottom: "1px solid #f0f0f0",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(22, 114, 222, 0.08) !important",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.12) !important",
                    },
                  },
                  "&:nth-of-type(even)": {
                    backgroundColor: "#fafafa",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                    },
                  },
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "1px solid #f0f0f0",
                  padding: "12px 16px",
                  fontSize: "13px",
                  color: "#333",
                  display: "flex",
                  alignItems: "center",
                  "&:focus": { outline: "none" },
                  "&:focus-within": { outline: "none" },
                },
                "& .MuiDataGrid-virtualScroller": {
                  "&::-webkit-scrollbar": {
                    width: "8px",
                    height: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#1672DE",
                    borderRadius: "10px",
                    "&:hover": {
                      background: "#1565c0",
                    },
                  },
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "2px solid #e0e0e0",
                  borderBottom: "none",
                  backgroundColor: "#f8f9fa",
                  minHeight: "56px",
                  maxHeight: "56px",
                  paddingBottom: "8px",
                  paddingTop: "8px",
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  position: "relative",
                  zIndex: 1,
                  display: "flex",
                  alignItems: "center",
                  "& .MuiTablePagination-root": {
                    color: "#666",
                    paddingRight: "16px",
                    margin: 0,
                    minHeight: "32px",
                  },
                  "& .MuiTablePagination-selectLabel": {
                    fontSize: "13px",
                    margin: 0,
                  },
                },
              }}
            />

            {/* Page number buttons beside "Showing x–y of z entries" */}
            <Box
              sx={{
                position: "absolute",
                right: 16,
                bottom: 14,
                zIndex: 2,
          display: "flex",
                alignItems: "center",
              }}
            >
              <CommonPaginationContainer
                count={paginationCount + 1}
                pageState={pageState}
                setPageState={setPageState}
              />
            </Box>
          </Box>
        </Box>
      </div>

      {/* <MyComponent /> */}

      <Dialog
        open={EntityDialog}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        PaperProps={{ 
          style: {
            maxWidth: "90vw",
            width: "90vw",
            margin: "auto",
          },
          sx: {
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          }
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ 
            cursor: "default", 
            paddingBottom: "0px",
            backgroundColor: "#ffffff",
            color: "#1672DE",
            fontWeight: "600",
            fontSize: "20px",
            padding: "20px 24px",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          {viewMode
            ? "View Correction Reason"
            : editMode
              ? "Edit Correction Reason"
              : "Add Correction Reason"}
          <IconButton
            aria-label="close"
            onClick={handleDialogClose}
            sx={{
              position: "absolute",
              right: 12,
              top: 12,
              color: "#666",
              "&:hover": {
                backgroundColor: "rgba(22, 114, 222, 0.1)",
                color: "#1672DE",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{ 
            overflowX: "hidden", 
            padding: "24px",
            backgroundColor: "#ffffff",
          }}
        >
          <div elevation={4} style={EditPageContainerTransactions}>
            {!editMode && !viewMode && (
              <div style={EditPageContainerTransactionsList}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <CommonButton
                    text="Add"
                    handleClick={handleAddRow}
                    icon={<AddIcon sx={{ ml: 0.5 }} />}
                    hoverColor="#1565c0"
                    sx={{
                      backgroundColor: "#1672DE",
                      color: "white",
                      borderRadius: "10px",
                      padding: "8px 16px",
                      fontWeight: "600",
                      fontSize: "14px",
                      textTransform: "none",
                      minHeight: "36px",
                      boxShadow: "0 2px 8px rgba(22, 114, 222, 0.2)",
                      "&:hover": {
                        backgroundColor: "#1565c0 !important",
                        boxShadow: "0 4px 12px rgba(22, 114, 222, 0.3)",
                        transform: "translateY(-1px)",
                      },
                    }}
                  />
                  <CommonButton
                    text="Delete"
                    handleClick={handleDeleteRow}
                    disabled={selectedRows.filter(Boolean).length === 0}
                    icon={<DeleteIcon sx={{ ml: 0.5 }} />}
                    hoverColor="rgba(244, 67, 54, 0.1)"
                    sx={{
                      backgroundColor: "transparent",
                      color: "#f44336",
                      border: "1px solid #f44336",
                      borderRadius: "10px",
                      padding: "8px 16px",
                      fontWeight: "600",
                      fontSize: "14px",
                      textTransform: "none",
                      minHeight: "36px",
                      "&:hover": {
                        backgroundColor: "rgba(244, 67, 54, 0.05)",
                        borderColor: "#d32f2f",
                        color: "#d32f2f",
                      },
                      "&:disabled": {
                        backgroundColor: "transparent",
                        color: "rgba(0, 0, 0, 0.26)",
                        borderColor: "#e0e0e0",
                      },
                    }}
                  />
                </div>
              </div>
            )}
            {isCreated ? (
              <TableContainer style={{ maxHeight: "300px" }}>
                <AddCorrection
                  selectAll={selectAll}
                  handleInputChange={handleInputChange}
                  handleSelectAll={handleSelectAll}
                  rows={rows}
                  handleCheckboxChange={handleCheckboxChange}
                  validationStatus={validationStatus}
                  selectedRows={selectedRows}
                  allocationStatus={allocationStatuss}
                />
              </TableContainer>
            ) : (
              <>
                {rows?.map((row, index) => (
                  <Grid display={"flex"} flexDirection={"column"}>
                    <ViewAndEditEntity
                      row={row}
                      index={index}
                      viewMode={viewMode}
                      validationStatus={validationStatus}
                      editMode={editMode}
                      handleInputChange={handleInputChange}
                      allocationStatus={allocationStatuss}
                    />
                  </Grid>
                ))}
              </>
            )}
          </div>
        </DialogContent>

        <DialogActions
          sx={{
            backgroundColor: "#ffffff",
            padding: "16px 24px",
            borderTop: "1px solid #e0e0e0",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
          {viewMode ? null : (
            <>
              {isCreated && (
                <CommonButton
                  text="Reset"
                  handleClick={() => handleReset()}
                  disabled={editMode}
                  hoverColor="rgba(22, 114, 222, 0.05)"
                  sx={{
                    backgroundColor: "transparent",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "10px",
                    padding: "10px 24px",
                    fontWeight: "600",
                    fontSize: "14px",
                    textTransform: "none",
                    minHeight: "40px",
                    minWidth: "120px",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.05)",
                      borderColor: "#1565c0",
                      color: "#1565c0",
                    },
                    "&:disabled": {
                      backgroundColor: "transparent",
                      color: "rgba(0, 0, 0, 0.26)",
                      borderColor: "#e0e0e0",
                    },
                  }}
                />
              )}
              {editMode && (
                <CommonButton
                  text="Update"
                  handleClick={handleSubmit}
                  disabled={Object.keys(currentUpdatedFiledsInEditMode)?.length <= 0}
                  hoverColor="#1565c0"
                  sx={{
                    backgroundColor: "#1672DE",
                    color: "white",
                    borderRadius: "10px",
                    padding: "10px 24px",
                    fontWeight: "600",
                    fontSize: "14px",
                    textTransform: "none",
                    minHeight: "40px",
                    minWidth: "120px",
                    boxShadow: "0 4px 16px rgba(22, 114, 222, 0.3)",
                    "&:hover": {
                      backgroundColor: "#1565c0",
                      boxShadow: "0 6px 24px rgba(22, 114, 222, 0.4)",
                      transform: "translateY(-1px)",
                    },
                    "&:disabled": {
                      backgroundColor: "#e0e0e0",
                      color: "#9e9e9e",
                      boxShadow: "none",
                      transform: "none",
                    },
                  }}
                />
              )}
              {!editMode && !viewMode && (
                <CommonButton
                  text="Submit"
                  handleClick={handleSubmit}
                  hoverColor="#1565c0"
                  sx={{
                    backgroundColor: "#1672DE",
                    color: "white",
                    borderRadius: "10px",
                    padding: "10px 24px",
                    fontWeight: "600",
                    fontSize: "14px",
                    textTransform: "none",
                    minHeight: "40px",
                    minWidth: "120px",
                    boxShadow: "0 4px 16px rgba(22, 114, 222, 0.3)",
                    "&:hover": {
                      backgroundColor: "#1565c0",
                      boxShadow: "0 6px 24px rgba(22, 114, 222, 0.4)",
                      transform: "translateY(-1px)",
                    },
                  }}
                />
              )}
              <CommonButton
                text="Cancel"
                handleClick={handleDialogClose}
                hoverColor="rgba(22, 114, 222, 0.05)"
                sx={{
                  backgroundColor: "transparent",
                  color: "#1672DE",
                  border: "1px solid #1672DE",
                  borderRadius: "10px",
                  padding: "10px 24px",
                  fontWeight: "600",
                  fontSize: "14px",
                  textTransform: "none",
                  minHeight: "40px",
                  minWidth: "120px",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.05)",
                    borderColor: "#1565c0",
                    color: "#1565c0",
                  },
                }}
              />
            </>
          )}
          {viewMode && (
            <CommonButton
              text="Close"
              handleClick={handleDialogClose}
              hoverColor="rgba(22, 114, 222, 0.05)"
              sx={{
                backgroundColor: "transparent",
                color: "#1672DE",
                border: "1px solid #1672DE",
                borderRadius: "10px",
                padding: "10px 24px",
                fontWeight: "600",
                fontSize: "14px",
                textTransform: "none",
                minHeight: "40px",
                minWidth: "120px",
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.05)",
                  borderColor: "#1565c0",
                  color: "#1565c0",
                },
              }}
            />
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}
